import AiBotPlaygroundAPI from 'dashboard/api/aiBot/playground';
import { throwErrorMessage } from '../../utils/api';

const types = {
  SET_UI_FLAG: 'SET_UI_FLAG',
  APPEND_EXCHANGE: 'APPEND_EXCHANGE',
  RESET: 'RESET',
};

export const state = {
  messages: [],
  trace: null,
  uiFlags: {
    isSending: false,
    isResetting: false,
  },
};

export const getters = {
  getMessages: $state => $state.messages,
  getTrace: $state => $state.trace,
  getUIFlags: $state => $state.uiFlags,
};

export const actions = {
  send: async ({ commit }, { botId, content }) => {
    commit(types.SET_UI_FLAG, { isSending: true });
    try {
      const response = await new AiBotPlaygroundAPI(botId).sendMessage({
        content,
      });
      commit(types.APPEND_EXCHANGE, {
        question: content,
        reply: response.data.reply,
        trace: response.data.trace,
      });
      return response.data;
    } catch (error) {
      throwErrorMessage(error);
      return null;
    } finally {
      commit(types.SET_UI_FLAG, { isSending: false });
    }
  },
  reset: async ({ commit }, { botId }) => {
    commit(types.SET_UI_FLAG, { isResetting: true });
    try {
      await new AiBotPlaygroundAPI(botId).reset();
      commit(types.RESET);
    } catch (error) {
      throwErrorMessage(error);
    } finally {
      commit(types.SET_UI_FLAG, { isResetting: false });
    }
  },
};

export const mutations = {
  [types.SET_UI_FLAG]($state, data) {
    $state.uiFlags = { ...$state.uiFlags, ...data };
  },
  [types.APPEND_EXCHANGE]($state, { question, reply, trace }) {
    $state.messages = [
      ...$state.messages,
      { role: 'user', content: question },
      { role: 'bot', content: reply?.content ?? '', traceId: trace?.id },
    ];
    $state.trace = trace;
  },
  [types.RESET]($state) {
    $state.messages = [];
    $state.trace = null;
  },
};

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
};
